const messages = {
  "title": "Overzicht vouchercodes",
  "short_description": "Hier vindt u een overzicht van de gebruikte vouchercodes.",
  "table": {
    "headers": {
      "voucher": "Voucher codes",
      "company": "Bedrijf",
      "street": "Straat",
      "postcode": "Postcode",
      "location": "Plaats",
      "solved_at": "Datun",
      "points": "Aantal punten via de code"
    }
  },
  "exchange": {
    "title": "Vul uw code in om punten te krijgen",
    "pointsLabel": "Vul hier de code in:",
    "result": "Aantal punten:"
  }
};

export default {
  messages,
};
